// @ts-ignore - Type import from vue-router causes conflicts with Ionic Vue Router
import type { RouteRecordRaw } from 'vue-router';
import store from '@/store';
export enum StaticPageTypes {
    main = 'MAIN',
    legal = 'LEGAL',
}
const fetchStaticData = (to, from, next) => {
    store.dispatch('addStaticPageContent', to.path.replace(/\//, ''));
    next();
};

const mainStaticPageRoutes: Array<RouteRecordRaw> = [
    {
        path: '/givingback',
        name: 'Giving Back',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
            seo: {
                title: 'Donatos Gives Back',
                description: 'Wherever We Serve Pizza, We Serve People. Part of Donatos Mission and Promise is giving back to the communities we serve.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/company',
        name: 'Our Story',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
            seo: {
                title: 'About Donatos Pizza',
                description:
                    'From the very beginning, our pizza love has been driven by People Love. The love of relationships. Seeing people together around pizza. Oh, and that sincere level of passion and care also drives us to make really, really good pizza. So, win-win.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/values',
        name: 'Values',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/news',
        name: 'News',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/fundraising',
        name: 'Fundraising',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/nutrition',
        name: 'Nutrition',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
            seo: {
                title: 'Donatos Nutrition & Allergen Info',
                description: 'Get information about calories, ingredients, gluten free menu items, allergens, and more for Donatos menu items.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/franchise',
        name: 'Franchise',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.main,
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/careers',
        name: 'Careers',
        component: () => import('@/views/careerPage.vue'),
        meta: {
            seo: {
                title: 'Donatos Careers',
                description: 'Join the Donatos Family and start building your future!',
            },
        },
    },
    {
        path: '/customer-service',
        name: 'Customer Service',
        component: () => import('@/views/customerService/customerServicePage.vue'),
        meta: {
            seo: {
                title: 'Contact Donatos Pizza',
                description: "Leave comments about your experience or call our Guest Services Team at 1-800-DONATOS (366-2867) and we'll get back to you within 1 business day.",
            },
        },
    },
    {
        path: '/:catchAll(.*)',
        meta: { type: StaticPageTypes.main },
        component: () => import('@/views/staticPage.vue'),
        beforeEnter: fetchStaticData,
    },
];

const legalPageRoutes: Array<RouteRecordRaw> = [
    {
        path: '/termsandconditions',
        name: 'Terms & Conditions',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
            seo: {
                title: 'Donatos Terms of Service',
                description: 'These terms of service are entered into by and between You and Donatos Pizzeria, LLC, when you use donatos.com, donatospizzafranchise.com, and the Donatos mobile app.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/privacy-policy',
        name: 'Privacy Policy',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
            seo: {
                title: 'Donatos Privacy Policy',
                description: 'Donatos respects your privacy and is committed to protecting it through our compliance with this policy.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/copyright',
        name: 'Copyright',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
            seo: {
                title: 'Donatos Copyright Information',
                description: 'Donatos Pizzeria, LLC takes claims of copyright infringement seriously, and will respond to notices of alleged copyright infringement that comply with applicable law.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/rewardsterms',
        name: 'Rewards Terms',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
            seo: {
                title: 'Donatos Rewards Terms & Conditions',
                description:
                    'Legal information about the Donatos Rewards Program, including Participation in and changes to the program, earning and redeeming points, terms and conditions, and more.',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/smsterms',
        name: 'SMS Terms',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
            seo: {
                title: 'Texts From Donatos: Terms & Conditions',
                description: 'Receive special text offers and deals from Donatos through your mobile device. Text PIZZA to 88188 to receive about 4 messages per month,',
            },
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/social-media-contest-terms',
        name: 'Social Media Contest Terms',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
        },
        beforeEnter: fetchStaticData,
    },
    {
        path: '/rewardsfaq',
        name: 'Rewards FAQ',
        component: () => import('@/views/staticPage.vue'),
        meta: {
            type: StaticPageTypes.legal,
            seo: {
                title: 'Donatos Rewards FAQ',
                description: "Q: Why should I sign up for rewards? A: You'll earn points toward rewards with every purchase. You don't need our app to earn points. And it's free to join!",
            },
        },
        beforeEnter: fetchStaticData,
    },
];

export default [...legalPageRoutes, ...mainStaticPageRoutes];
